'use client';

import { useMemo } from 'react';

import type { ToolPartRenderer } from '@/features/copilot/model';

import { UpdateTextFieldToolCard } from './tools/update-text-field';

export function useCopilotToolPartRenderers(): Readonly<Record<string, ToolPartRenderer>> {
  return useMemo(
    (): Record<string, ToolPartRenderer> => ({
      updateTextField: (props) => <UpdateTextFieldToolCard {...props} />,
    }),
    []
  );
}
